export default __webpack_public_path__ + "static/media/overheads.6b62d166.svg";